import $ from '~/assets/js/lib/jquery-3.6.0.min.js';

$(function () {
  $('.p-executives-card').each(function () {
    const $this = $(this);
    const $reserveEl = $this.find('.p-executives-card__body');

    if (location.pathname.indexOf('english') !== -1) {
      $this.find('.c-circle-arrow').remove();
    } else {
      if ($reserveEl.length) {
        $this.addClass('isOpen');
        $reserveEl.show();
        $this.on('click', function () {
          $reserveEl.slideToggle();
          $this.toggleClass('isOpen');
        });
      } else {
        $this.find('.c-circle-arrow').remove();
      }
    }
  });

  $('a[href^="#"]').not('.no-scroll').on('click', ankerLink);
  changeContentTab('.p-tab-article__tab li a', '.p-tab-article__body');
  changeContentTab('.p-tab-article__categories li a', '#tabAll .p-history-list');
  $('a[data-modal-target]').on('click', toggleModal);

  function toggleModal () {
    const $this = $(this);
    const $target = $($this.data('modal-target'));
    const $closeButton = $target.find('.js-close');
    $target.addClass('isShow');

    $($target).children('div').on('click', e => {
      e.stopPropagation();
    });

    const handleCancel = () => {
      $target.removeClass('isShow');
      $target.addClass('isHide');

      $target.off('click', handleCancel);
      $closeButton.off('click', handleCancel);
      setTimeout(function () {
        $target.removeClass('isHide');
      }, parseFloat($target.css('animation-duration')) * 1000);
    };

    $closeButton.on('click', handleCancel);
    $target.on('click', handleCancel);
  }

  function ankerLink () {
    const speed = 500;
    const href = $(this).attr('href');
    const target = $(href === '#' || href === '' ? 'html' : href);
    let position = target.offset().top;

    if ($('.l-header').length) {
      position -= $('.l-header').height();
    }

    $('html, body').animate({ scrollTop: position }, speed, 'swing');
    return false;
  }

  function changeContentTab (tabEl, contentEl) {
    $(tabEl).off('click', ankerLink);
    $(tabEl).on('click', function () {
      const $this = $(this);
      const $reserveEl = $($this.data('tab-target'));
      const $previousEl = $(contentEl).filter('.isActive');

      $this.parents('ul').find('.isActive').removeClass('isActive');
      $this.addClass('isActive');

      $previousEl.removeClass('isActive');
      $reserveEl.addClass('isActive');
      return false;
    });
  }
});
